<template>
  <!-- 交接异常工单 -->
  <div class="Box">
    <el-form>
      <el-row type="flex" justify="left" style="flex-wrap: wrap;align-items: center">
        <el-col :span="7">
          <el-form-item :label="$t('collectionCenter.RegistrationT')">
            <el-date-picker
              v-model="timeValue"
              :clearable="false"
              :default-time="['00:00:00', '23:59:59']"
              :end-placeholder="$t('collectionCenter.EndTime')"
              :range-separator="$t('collectionCenter.to')"
              :start-placeholder="$t('collectionCenter.StartTime')"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 90%"
              @change="dateChange"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!--运单号-->
          <el-form-item>
            <el-select v-model="numberType" @change="numberTypeChange" style="width: 90%">
              <el-option key="1" :label="$t('GlobalSetObj.waybillNumber')" :value="0" /><!--运单号-->
              <el-option key="2" :label="$t('GlobalSetObj.ScanNumber')" :value="1" /><!--扫描单号-->
              <el-option key="3" :label="$t('collectionCenter.workOrderNumber')" :value="2" /><!--工单编号-->
            </el-select>
            <br>
            <el-input
              v-model="numberBox"
              :placeholder="$t('collectionCenter.BatchQuery')"
              :rows="1"
              type="textarea"
              style="width: 90%"
              @blur="numberBoxChange"
              @keydown.enter.native="numberBoxChange"
            />
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <!--搜索-->
          <el-button
            size="small" type="primary" @click="search"
          >{{ $t('newOrder.search') }}
          </el-button>
          <!--重置-->
          <el-button
            size="small" @click="resetForm"
          >{{ $t('newOrder.reset') }}
          </el-button>
          <!--高级搜索-->
          <el-button
            size="small" type="primary" @click="advancedSearch"
          >{{ $t('home.advancedSearch') }}
          </el-button>
        </el-col>
      </el-row>
    </el-form>
    <div>
      <el-button
        v-permit:remove="'btn:quality-service:handover-exception:bulkImport'"
        size="small" type="primary"
        @click="allImportOrder"
      >{{ $t('newOrder.bulkImport') }}
      </el-button><!--批量导入-->
      <el-button
        size="small" @click="download"
      >{{ $t('collectionCenter.export') }}</el-button><!-- 导出 -->
      <el-button
        v-permit:remove="'btn:quality-service:handover-exception:modifyResult'"
        size="small" @click="editResult"
      >{{ $t('collectionCenter.modifyResult') }}</el-button><!-- 修改处理结果 -->
    </div>

    <!--  高级搜索  -->
    <searchCom ref="searchComRef" @child-search="childSearch" />

    <el-tabs v-model="ticketType" @tab-click="handleClick">
      <el-tab-pane :label="$t('collectionCenter.tudo')" name="all">
        <template slot="label">
          <div>{{ $t('collectionCenter.tudo') }} {{ statistics.allQuantity }}</div>
        </template>
      </el-tab-pane>
      <el-tab-pane :disabled="statistics.reportedQuantity === 0" :label="$t('collectionCenter.myReported') + ' ' + statistics.reportedQuantity" name="1" />
      <el-tab-pane :disabled="statistics.disposeQuantity === 0" :label="$t('collectionCenter.myPending') + ' ' + statistics.disposeQuantity" name="2" />
    </el-tabs>
    <el-table
      ref="tableRef"
      :data="tableData"
      border
      max-height="600"
      row-key="id"
      style="width: 100%"
      @selection-change="selectionChange"
    >
      <el-table-column
        align="center" fixed="left" type="selection"
        width="50"
      />
      <el-table-column
        :label="$t('GlobalSetObj.serial')" type="index" width="55"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="item in tableHeaderList"
        :key="item.id"
        :align="item.align"
        :label="item.label"
        :min-width="item.cloWidth"
        :prop="item.prop"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="item.prop === 'ticketStatusName'">
            <!-- 1.待处理、2.处理中、3.部分结束、4.全部结束 -->
            <el-tag
              v-if="scope.row['ticketStatus'] === 1" type="success"
            >{{ $t('GlobalSetObj.Pending') }}</el-tag>
            <el-tag
              v-else-if="scope.row['ticketStatus'] === 2"
            >{{ $t('newOrder.processing') }}</el-tag>
            <el-tag
              v-else-if="scope.row['ticketStatus'] === 3" type="warning"
            >{{ $t('collectionCenter.partiallyCompleted') }}</el-tag>
            <el-tag
              v-else-if="scope.row['ticketStatus'] === 4" type="danger"
            >{{ $t('collectionCenter.fullyCompleted') }}</el-tag>
            <span v-else>--</span>
          </div>
          <div v-else-if="item.prop === 'detailSum'">
            <div
              v-if="scope.row['detailSum']"
              class="detailSum_class"
              @click="detailMsgClick(scope.row)"
            >
              {{ scope.row['detailSum'] }}
            </div>
            <span v-else>--</span>
          </div>
          <div v-else>
            <div>{{ scope.row[item.prop] || '--' }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="操作（Ação）" align="center" fixed="right"
        width="180"
      >
        <template slot-scope="scope">
          <div class="operation_class">
            <span
              v-permit:remove="'btn:quality-service:handover-exception:Reply'"
              @click="replyMessage(scope.row)"
            >
              <!--  回复  -->{{ $t('GlobalSetObj.Reply') }}
            </span>
            <span
              v-permit:remove="'btn:quality-service:handover-exception:over'"
              v-if="scope.row['ticketStatus'] !== 4 && scope.row['ticketType'] !== 1" @click="processRClick(scope.row)"
            >
              <!--  结束  -->{{ $t('collectionCenter.end') }}
            </span>
            <span @click="imageOpenClick(scope.row)">
              <!--  图片  -->{{ $t('collectionCenter.picture') }}
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="queryForm.pageNumber"
      :page-size="queryForm.pageSize"
      :page-sizes="[10, 50, 100, 500, 1000]"
      :total="total"
      background
      layout="total, sizes, prev, pager, next, jumper"
      style="margin: 10px 0; float: right"
      @size-change="getPageSize"
      @current-change="handleCurrentChange"
    />
    <div style="height: 50px" />

    <!-- 批量导入 -->
    <el-drawer
      :wrapper-closable="false"
      :close-on-click-modal="false"
      :title="$t('basicData.BulkImport')"
      :visible.sync="bulkImportDialogVisible"
      direction="ltr"
      size="600px"
      @close="bulkImportCloseDrawer"
    >
      <bulkImport ref="bulkImportRef" @bIClose="bulkImportCloseDrawer" @toSearch="handleCurrentChange" />
    </el-drawer>

    <!--回复弹窗-->
    <el-drawer
      :close-on-click-modal="true"
      :destroy-on-close="true"
      :title="$t('collectionCenter.messageRecord')"
      :visible.sync="seeDialogVisible"
      class="drawerClass"
      direction="ltr"
      size="1000px"
      @close="closeDrawer"
    >
      <messageDetail ref="messageDetailRef" :reply-message-data="replyMessageData" />
    </el-drawer>

    <!--处理结果-->
    <el-dialog
      :title="$t('collectionCenter.processingResult')"
      :visible.sync="processRDialogVisible"
      width="30%"
      :before-close="processRClose"
    >
      <div style="font-size: 15px; font-weight: bold; color: #67696d">
        {{ $t('GlobalSetObj.totalOptions') }}：{{ processResultForm.ids.length }}
      </div>
      <el-form ref="processRFormRef" :model="processResultForm" label-position="top" style="margin: 10px">
        <el-row>
          <el-col :span="24">
            <!-- 处理结果 -->
            <el-form-item
              :label="$t('collectionCenter.processingResult') + '：'" prop="handlingResult"
              :rules="[{ required: true, message: $t('GlobalSetObj.pleaseChoose'), trigger: 'change' }]"
            >
              <el-select
                v-model="processResultForm.handlingResult"
                :placeholder="$t('collectionCenter.pleaseChoose')" clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in processResultList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="processRClose">{{ $t('GlobalSetObj.cancel') }}</el-button>
        <el-button type="primary" @click="processRSubmit">{{ $t('GlobalSetObj.confirm') }}</el-button>
      </span>
    </el-dialog>

    <!--查看图片-->
    <el-dialog
      :title="$t('navbar.seeImage')"
      :visible.sync="imgDialogVisible"
      width="50%"
      :before-close="imgClose"
    >
      <el-row class="imgBox">
        <el-col
          v-for="(item, index) in srcList" :key="index"
          :span="7" style="margin-bottom: 10px; margin-right: 10px"
        >
          <el-image
            style="width: 100%"
            :src="item" fit="contain"
            :preview-src-list="srcList"
          />
        </el-col>
      </el-row>
    </el-dialog>

    <!--运单明细-->
    <el-drawer
      :close-on-click-modal="true"
      :destroy-on-close="true"
      :title="$t('GlobalSetObj.DetailOfwaybill')"
      :visible.sync="waybillDetailVisible"
      direction="ltr"
      size="70%"
      @close="waybillDetailClose"
    >
      <waybillDetail ref="waybillDetailRef" :way-id="waybillId" />
    </el-drawer>
  </div>
</template>

<script>
import {
  handoverAbnormalityStatistics,
  handoverAbnormalityPage,
  handoverAbnormalityExport,
  handoverAbnormalityResults
} from '@/api/newExpressAPI';
import dayjs from 'dayjs';
import { goResourceTaskList } from '@/utils/goExportList.js';
import { Loading } from 'element-ui';

export default {
  name: 'HandoverException',
  components: {
    searchCom: () => import('./component/searchCom.vue'),
    messageDetail: () => import('./component/messageDetail.vue'),
    bulkImport: () => import('./component/bulkImport.vue'),
    waybillDetail: () => import('./component/waybillDetail.vue')
  },
  data() {
    return {
      ticketType: 'all',
      timeValue: [],
      numberType: 0,
      numberBox: '',
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          registrationStartTime: '',
          registrationEndTime: '',
          waybillNumberList: [], // 运单号
          scanNumberList: [], // 扫描单号
          ticketNumberList: [], // 工单编号
          handlingResult: null, // 处理结果 1.上游责任、2.下游责任、3.无责、4.超时未回复
          handlingRegionList: [], // 处理大区
          handlingSiteList: [], // 处理网点
          reportRegionList: [], // 上报大区
          reportSiteList: [], // 上报网点
          registrationUserList: [], // 登记人
          endOperationPersonList: [], // 结束操作人
          ticketType: null,
          registrationSource: null // 登记来源,0快递系统,1服务商系统
        }
      },
      statistics: {}, // 统计数据
      total: 0,
      tableData: [],
      tableHeaderList: [
        { id: 1, label: '工单编号（Número do chamado）', prop: 'ticketNumber', cloWidth: '150', align: 'center' },
        { id: 2, label: '登记时间（Data de registro）', prop: 'createTime', cloWidth: '150', align: 'center' },
        { id: 3, label: '事件类型（Tipo de evento）', prop: 'eventTypeName', cloWidth: '150', align: 'center' },
        { id: 4, label: '状态（Status）', prop: 'ticketStatusName', cloWidth: '150', align: 'center' },
        { id: 5, label: '工单类型（Tipo do chamado）', prop: 'ticketTypeName', cloWidth: '150', align: 'center' },
        { id: 6, label: '处理结果（Comentário de tratamento）', prop: 'handlingResultName', cloWidth: '180', align: 'center' },
        { id: 7, label: '处理大区（Região de tratamento）', prop: 'handlingRegionName', cloWidth: '150', align: 'center' },
        { id: 8, label: '处理网点（Ponto de tratamento）', prop: 'handlingSiteName', cloWidth: '150', align: 'center' },
        { id: 9, label: '相关运单数（Conhecimentos Relacionados）', prop: 'detailSum', cloWidth: '180', align: 'center' },
        { id: 10, label: '上报大区（Região de reporte）', prop: 'reportRegionName', cloWidth: '150', align: 'center' },
        { id: 11, label: '上报网点（Ponto de reporte）', prop: 'reportSiteName', cloWidth: '150', align: 'center' },
        { id: 12, label: '描述（Descrição）', prop: 'description', cloWidth: '150', align: 'center' },
        { id: 13, label: '截止时间（Data de vencimento）', prop: 'deadlineTime', cloWidth: '150', align: 'center' },
        { id: 14, label: '是否有最新回复（Existe uma resposta atualizada）', prop: 'latestReply', cloWidth: '200', align: 'center' },
        { id: 15, label: '最新回复时间（Tempo de resposta mais recente）', prop: 'latestReplyTime', cloWidth: '200', align: 'center' },
        { id: 16, label: '最新回复内容（Último que respondeu）', prop: 'latestReplyContent1', cloWidth: '180', align: 'center' },
        { id: 17, label: '登记人（Pessoa que registrou）', prop: 'registrant', cloWidth: '150', align: 'center' },
        { id: 18, label: '结束操作时间（Hora de término da operação）', prop: 'endOperationTime', cloWidth: '180', align: 'center' },
        { id: 19, label: '结束操作人（Pessoa de término da operação）', prop: 'endTheOperator', cloWidth: '180', align: 'center' }
      ],
      selectData: [],

      // 回复弹窗
      seeDialogVisible: false,
      replyMessageData: null,
      // 处理结果
      processRDialogVisible: false,
      processResultForm: {
        ids: [],
        handlingResult: null,
        operateType: null
      },
      processResultList: [
        { id: 1, name: this.$t('collectionCenter.upstreamResponsibility') }, // 上游责任
        { id: 2, name: this.$t('collectionCenter.downstreamResponsibility') }, // 下游责任
        { id: 3, name: this.$t('GlobalSetObj.blameless') } // 无责
      ],
      // 查看图片
      imgDialogVisible: false,
      srcList: [],
      // 批量导入
      bulkImportDialogVisible: false,

      // 运单明细
      waybillDetailVisible: false,
      waybillId: null
    };
  },
  created() {
    this.resetForm();
    this.getStatistics();
  },
  methods: {
    getStatistics() {
      handoverAbnormalityStatistics(this.queryForm.params).then(res => {
        if (res.code === 200) {
          this.statistics = res.data;
        }
      });
    },
    handleClick() {
      this.queryForm.params.ticketType = this.ticketType === 'all' ? null : Number(this.ticketType);
      this.selectData = [];
      this.queryForm.pageNumber = 1;
      this.handleCurrentChange();
    },
    dateChange(val) {
      if (val === null) {
        this.timeValue = [];
        this.queryForm.params.registrationStartTime = '';
        this.queryForm.params.registrationEndTime = '';
        return;
      }
      this.timeValue = [val[0], val[1]];
      this.queryForm.params.registrationStartTime = val[0];
      this.queryForm.params.registrationEndTime = val[1];
      if (val[1]) {
        const endTime = dayjs(val[0]).subtract(-1, 'year').format('YYYY-MM-DD') + ' 23:59:59';
        if (val[1] > endTime) {
          this.$message({
            // 最多可查询到一年的数据
            message: this.$t('collectionCenter.moreYear'),
            type: 'warning'
          });
          const d = new Date();
          const today = dayjs(d).format('YYYY-MM-DD');
          const threeDaysAgo = dayjs(d).subtract(2, 'day').format('YYYY-MM-DD');
          this.timeValue = [threeDaysAgo + ' 00:00:00', today + ' 23:59:59'];
          this.queryForm.params.registrationStartTime = threeDaysAgo + ' 00:00:00';
          this.queryForm.params.registrationEndTime = today + ' 23:59:59';
        }
      }
    },
    numberTypeChange() {
      this.numberBox = '';
      this.queryForm.params.waybillNumberList = [];
      this.queryForm.params.scanNumberList = [];
      this.queryForm.params.ticketNumberList = [];
    },
    numberBoxChange() {
      if (this.numberBox) {
        let lines = this.numberBox.split('\n')
          .filter((line) => line && line.trim())
          .map((line) => line.replace(/\s/g, '').trim());
        if (lines.length > 2000) {
          lines = lines.slice(0, 2000);
          this.$message.warning(this.$t('collectionCenter.intercep2'));
        }
        this.numberBox = lines.join('\n');
        if (this.numberType === 0) {
          this.queryForm.params.waybillNumberList = this.numberBox.split('\n');
        } else if (this.numberType === 1) {
          this.queryForm.params.scanNumberList = this.numberBox.split('\n');
        } else if (this.numberType === 2) {
          this.queryForm.params.ticketNumberList = this.numberBox.split('\n');
        }
      } else {
        this.numberBox = '';
        this.queryForm.params.waybillNumberList = [];
        this.queryForm.params.scanNumberList = [];
        this.queryForm.params.ticketNumberList = [];
      }
    },
    search() {
      if (!this.numberBox && (!this.timeValue || this.timeValue.length <= 0)) {
        this.$message.warning(this.$t('collectionCenter.PleaseSelectTime'));
        return;
      }
      this.ticketType = 'all';
      this.queryForm.params.ticketType = null;
      this.getStatistics();
      this.selectData = [];
      this.queryForm.pageNumber = 1;
      this.handleCurrentChange();
    },
    // 分页
    getPageSize(newSize) {
      this.queryForm.pageNumber = 1;
      this.queryForm.pageSize = newSize;
      this.handleCurrentChange();
    },
    handleCurrentChange(newPage) {
      if (newPage !== undefined && newPage !== null) {
        this.queryForm.pageNumber = newPage;
      }
      const loading = Loading.service({
        fullscreen: true,
        lock: true,
        spinner: 'el-icon-loading',
        text: 'loading...',
        background: 'rgba(250, 250, 250, 0.6)'
      });
      handoverAbnormalityPage(this.queryForm).then(res => {
        if (res.code === 200) {
          this.total = res.data.total;
          this.tableData = res.data.records.map(arr => {
            const latestReplyContent1 = arr.latestReplyContent ? this.removeHtml(arr.latestReplyContent) : '';
            return {
              latestReplyContent1,
              ...arr
            };
          });
        }
      }).finally(() => {
        loading.close();
      });
    },
    removeHtml(html) {
      return html ? html.replace(/<[^>]*>/g, '') : '';
    },
    resetForm() {
      const today = dayjs().format('YYYY-MM-DD');
      const threeDaysAgo = dayjs().subtract(2, 'day').format('YYYY-MM-DD');
      this.timeValue = [threeDaysAgo + ' 00:00:00', today + ' 23:59:59'];
      this.numberBox = '';
      this.numberType = 0;
      this.queryForm.params = {
        registrationStartTime: threeDaysAgo + ' 00:00:00',
        registrationEndTime: today + ' 23:59:59',
        waybillNumberList: [],
        scanNumberList: [], // 扫描单号
        ticketNumberList: [], // 工单编号
        handlingResult: null, // 处理结果 1.上游责任、2.下游责任、3.无责、4.超时未回复
        handlingRegionList: [], // 处理大区
        handlingSiteList: [], // 处理网点
        reportRegionList: [], // 上报大区
        reportSiteList: [], // 上报网点
        registrationUserList: [], // 登记人
        endOperationPersonList: [], // 结束操作人
        ticketType: null,
        registrationSource: null // 登记来源,0快递系统,1服务商系统
      };
      this.ticketType = 'all';
      this.search();
      this.$nextTick(() => {
        if (this.$refs.searchComRef) {
          this.$refs.searchComRef.resetForm();
        }
      });
    },
    // 高级搜索
    advancedSearch() {
      this.$refs.searchComRef.showDialog();
    },
    childSearch(form) {
      this.queryForm.params.handlingResult = form.handlingResult;
      this.queryForm.params.handlingRegionList = form.handlingRegionList;
      this.queryForm.params.handlingSiteList = form.handlingSiteList;
      this.queryForm.params.reportRegionList = form.reportRegionList;
      this.queryForm.params.reportSiteList = form.reportSiteList;
      this.queryForm.params.registrationUserList = form.registrationUserList;
      this.queryForm.params.endOperationPersonList = form.endOperationPersonList;
      this.queryForm.params.registrationSource = form.registrationSource;
      this.search();
    },
    /**
     * 批量导入-------------start
     */
    allImportOrder() {
      this.bulkImportDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.bulkImportRef.bulkImportOpen();
      });
    },
    bulkImportCloseDrawer() {
      this.bulkImportDialogVisible = false;
    },
    /**
     * 批量导入-------------end
     */

    /**
     * 运单详情-------------start
     */
    detailMsgClick(row) {
      this.waybillId = row;
      this.waybillDetailVisible = true;
      this.$nextTick(() => {
        if (this.$refs.waybillDetailRef) {
          this.$refs.waybillDetailRef.waybillSearch();
        }
      });
    },

    // 明细
    waybillDetailClose() {
      this.waybillDetailVisible = false;
      this.search();
    },
    /**
     * 运单详情-------------end
     */

    /**
     * 回复弹窗-------------start
     */
    // 点击回复弹框
    replyMessage(row) {
      this.seeDialogVisible = true;
      this.replyMessageData = row;
      this.$nextTick(() => {
        this.$refs.messageDetailRef.getMessageData();
      });
    },
    closeDrawer() {
      clearInterval(this.$refs.messageDetailRef.getIntervalMsg);
      this.search();
    },
    /**
     * 回复弹窗-------------end
     */

    /**
     * 处理结果-------------start
     */
    processRClick(row) {
      this.processRDialogVisible = true;
      this.processResultForm.ids = [row.id];
      this.processResultForm.operateType = 2;
    },
    processRClose() {
      this.processRDialogVisible = false;
      this.processResultForm.handlingResult = null;
      this.processResultForm.operateType = null;
      this.$refs.processRFormRef.clearValidate();
    },
    processRSubmit() {
      this.$refs.processRFormRef.validate((valid) => {
        if (valid) {
          handoverAbnormalityResults(this.processResultForm).then(res => {
            if (res.code === 200) {
              this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded')); // 操作成功
              this.processRClose();
              this.search();
            }
          });
        } else {
          // 校验失败提示
          return false;
        }
      });
    },
    /**
     * 处理结果-------------end
     */

    /**
     * 查看图片-------------start
     */
    imageOpenClick(row) {
      this.imgDialogVisible = true;
      this.srcList = row.ticketPictureList;
    },
    imgClose() {
      this.imgDialogVisible = false;
      this.srcList = [];
    },
    /**
     * 查看图片-------------end
     */
    // 勾选
    selectionChange(select) {
      this.selectData = select;
    },
    // 导出
    download() {
      handoverAbnormalityExport(this.queryForm.params).then(res => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    // 修改处理结果
    editResult() {
      if (this.selectData.length <= 0) {
        this.$message.warning(this.$t('collectionCenter.checkMsg')); // '请勾选数据'
        return;
      }
      // 过滤
      const validData = this.selectData.filter(item => {
        return item.ticketStatus === 4 && item.ticketType === 2;
      });
      if (validData.length === 0) {
        this.$message.warning(this.$t('collectionCenter.modifyPermission'));
        return;
      }
      if (validData.length < this.selectData.length) {
        const filteredCount = this.selectData.length - validData.length;
        this.$message.warning(`${this.$t('collectionCenter.filteredInvalidData1')}${filteredCount}${this.$t('collectionCenter.filteredInvalidData2')}`);
        this.$nextTick(() => {
          this.$refs.tableRef.clearSelection();
          validData.forEach(row => {
            this.$refs.tableRef.toggleRowSelection(row, true);
          });
        });
      }

      const idList = validData.map(arr => {
        return arr.id;
      });
      this.processRDialogVisible = true;
      this.processResultForm.ids = idList;
      this.processResultForm.operateType = 1;
    }
  }
};
</script>

<style lang="scss" scoped>
.Box{
  padding: 20px;
  box-sizing: border-box;
}
.right{
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.Box ::v-deep .el-divider--horizontal {
  margin-top: 5px !important;
}
.operation_class {
  color: #4aa3ff;
  display: flex;
  justify-content: space-around;
  align-items: center;
  span {
    cursor: pointer;
    white-space: nowrap;
  }
}
.drawerClass ::v-deep .el-drawer__body {
  overflow-y: auto;
}
.imgBox {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}
.detailSum_class {
  color: #2392ff;
  cursor: pointer;
}
</style>
